import dialogs, { BaseDialog } from '~/widgets/BaseDialogs/BaseDialogs'
import swal from 'sweetalert';

import ShareDialogs from './ShareDialogs'

import './ShareMenuModal.scss'

export default { open }

function open(href) {
    if (navigator.share) {
        navigator.share({
            title: document.title,
            text: '',
            url: href
        })
    }
    else {
        dialogs.open(
            <BaseDialog title='Compartilhar com'>
                <button className='share-menu-modal-item' onClick={() => shareWithWhatsapp(href)}>
                    <i className='fa fa-whatsapp'></i> Whatsapp
                </button>
                <button className='share-menu-modal-item' onClick={() => shareWithFacebook(href)}>
                    <i className='fa fa-facebook'></i> Facebook
                </button>
            </BaseDialog>
        )
    }
}

function shareWithWhatsapp(href) {
    if (!href) {
        return
    }
    ShareDialogs.openWhatsapp({ href })
}

function shareWithFacebook(href) {
    if (!href) {
        return
    }
    FB.ui({
        method: 'share',
        quote: '',
        href
    }, function (response) { console.log(response) });
    swal.close()
}
